import { HorizontalSidetracking, PerforationAndReperforation, RepairAndInsulationWorks, Returns, StratumHydraulicFracturing, TreatmentOfBottomholeZone, WellOperationModeOptimization } from '.';

export const GTM15_ICONS_CONFIG = {
    treatmentOfBottomholeZone: {
        key: 'treatmentOfBottomholeZone',
        title: 'Обработка призабойной зоны (ОПЗ)',
        shortTitle: 'ОПЗ',
        icon: TreatmentOfBottomholeZone,
    },
    stratumHydraulicFracturing: {
        key: 'stratumHydraulicFracturing',
        title: 'Гидро разрыв пласта',
        shortTitle: 'ГРП',
        icon: StratumHydraulicFracturing,
    },
    perforationAndReperforation: {
        key: 'perforationAndReperforation',
        title: 'Дострел, перестрел',
        icon: PerforationAndReperforation,
    },
    repairAndInsulationWorks: {
        key: 'repairAndInsulationWorks',
        title: 'Ремонтно-Изоляционные Работы',
        shortTitle: 'РИР',
        icon: RepairAndInsulationWorks,
    },
    wellOperationModeOptimization: {
        key: 'wellOperationModeOptimization',
        title: 'Оптимизация режима работы скважины',
        shortTitle: 'Оптимизация',
        icon: WellOperationModeOptimization,
    },
    horizontalSidetracking: {
        key: 'horizontalSidetracking',
        title: 'Зарезка (Горизонтального) Бокового Ствола',
        shortTitle: 'ЗБГС',
        icon: HorizontalSidetracking,
    },
    returns: {
        key: 'returns',
        title: 'Возвраты',
        icon: Returns,
    },
};

export const GTM15_ICONS_OPTIONS = Object.values(GTM15_ICONS_CONFIG).map(({ key, icon: Icon, shortTitle, title }) => ({
    value: key,
    label: (
        <div className="flex items-center gap-x-2">
            <Icon />
            <span>{shortTitle ?? title}</span>
        </div>
    ),
}));
